<!-- <li class="panel"> -->
<div class="controparte">
	<div>
		<p class="col-sm-2">
			<button (click)="emitEntity(fattura)" class="btn btn-primary associa"
				type="submit">Allega</button>
		</p>
		<h4 class="titolo col-sm-3">{{fattura.altraParte.parte.nominativo}}</h4>
		<p class="col-sm-2">
			<strong>{{fattura.altraParte.categoriaAltraParte?.descrizione}}</strong>
		</p>
		<p class="col-sm-3">
			Fattura: <strong>{{fattura.numeroFattura}} del
				{{fattura.dataEmissione | date:'dd/MM/yyyy'}}</strong>
		</p>
		<p class="col-sm-2">
			Importo: <strong>{{fattura.totaleImportoAttivita | euro}}
				&euro;</strong>
		</p>
	</div>
</div>
<!-- </li> -->
